import React from 'react';
import { Container } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { QRCodeCanvas } from 'qrcode.react';
import { FaQrcode } from 'react-icons/fa';
import AdminPageHeader from './AdminPageHeader';

const reactLogo = `/logo192.png`;

function ModuleQRCode() {
    const location = useLocation();

    // Ambil id dari query parameter
    const searchParams = new URLSearchParams(location.search);
    const id = searchParams.get("id");

    const qrValue = id ? `${id}` : 'checkin'; // fallback jika tidak ada id

    return (
        <div>
            <Container fluid className="admin-page-shell mt-4 px-4 text-center">
                <AdminPageHeader
                    icon={FaQrcode}
                    eyebrow="QR utility"
                    title="Check-in QR Code"
                    description="Gunakan QR code ini untuk kebutuhan proses check-in yang terintegrasi dengan sistem."
                    breadcrumbs={[
                        { label: 'Dashboard', to: '/dashboardadmin' },
                        { label: 'Check-in QR Code' },
                    ]}
                />
                <div className="section-card" style={{ display: 'inline-block', padding: '1.5rem 2rem' }}>
                    <QRCodeCanvas
                        value={qrValue}
                        size={256}
                        includeMargin={true}
                        level="H"
                        imageSettings={{
                            src: reactLogo,
                            height: 40,
                            width: 40,
                            excavate: true,
                        }}
                    />
                </div>
            </Container>
        </div>
    );
}

export default ModuleQRCode;
